// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".image-header{min-height:40vh;background-color:transparent;background-repeat:no-repeat;background-position:center left;padding-top:30px;padding-bottom:30px}.image-header .title{display:inline;vertical-align:middle}\n", ""]);
// Exports
module.exports = exports;
